export const getIsFirefox = () => navigator.userAgent.includes('Firefox');

/**
 * Firefox does not restrict input values like other browsers, so we are
 * manually doing this here.  This is not as good as how Chrome does it
 * because text number inputs behave very strangely.  The key issue is
 * if the current input value is invalid inputRef.current.value returns an
 * empty string,  This makes it hard to restrict the input to have only
 * one occurrence of 'e', '+', or '-' like Chrome does. What we have here
 * is close to that but not quite, because if the input value is invalid
 * we can't do anything to restrict input because we can't see what it
 * currently is.
 */
export const firefoxNumberInputWorkaround = _ref => {
  var _inputRef$current, _inputRef$current$val;
  let {
    event,
    inputRef
  } = _ref;
  if (event.key.length > 1) {
    // This is not an alphnumeric character key, this could be backspace, enter, etc
    return;
  }
  if (event.ctrlKey || event.metaKey) {
    // User is probably trying to select with keyboard shortcut
    return;
  }
  if (!event.key.match(/^[0-9+-\.e]$/)) {
    event.preventDefault();
  } else if (event.key.match(/[+-]|e/) && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && (_inputRef$current$val = _inputRef$current.value) !== null && _inputRef$current$val !== void 0 && _inputRef$current$val.includes(event.key)) {
    event.preventDefault();
  }
};
//# sourceMappingURL=firefox.js.map